import { getUserId } from "./basicPlanAccess";

const CONTINUE_LEARNING_STORAGE_PREFIX = "continueLearning";

const getStorageKey = (user) => {
  const userId = getUserId(user);
  if (!userId) return "";
  return `${CONTINUE_LEARNING_STORAGE_PREFIX}:${userId}`;
};

const canUseStorage = () => typeof window !== "undefined" && window.localStorage;

const normalizeQuestionIndex = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

export const readContinueLearning = (user) => {
  if (!canUseStorage()) return null;

  const storageKey = getStorageKey(user);
  if (!storageKey) return null;

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;

    return {
      ...parsed,
      yearId: Number(parsed.yearId) || 0,
      lessonId: Number(parsed.lessonId) || 0,
      lessonIndex: normalizeQuestionIndex(parsed.lessonIndex),
      questionIndex: normalizeQuestionIndex(parsed.questionIndex),
      phase: parsed.phase === "questions" ? "questions" : "video",
    };
  } catch (_error) {
    return null;
  }
};

export const saveContinueLearning = (user, payload) => {
  if (!canUseStorage()) return;

  const storageKey = getStorageKey(user);
  if (!storageKey || !payload || typeof payload !== "object") return;

  const existing = readContinueLearning(user) || {};
  const nextValue = {
    ...existing,
    ...payload,
    questionIndex: normalizeQuestionIndex(payload.questionIndex ?? existing.questionIndex),
    lessonIndex: normalizeQuestionIndex(payload.lessonIndex ?? existing.lessonIndex),
    updatedAt: new Date().toISOString(),
  };

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(nextValue));
  } catch (_error) {
    // Ignore storage failures.
  }
};

export const clearContinueLearning = (user) => {
  if (!canUseStorage()) return;

  const storageKey = getStorageKey(user);
  if (!storageKey) return;

  try {
    window.localStorage.removeItem(storageKey);
  } catch (_error) {
    // Ignore storage failures.
  }
};

export const buildContinueLearningLessonUrl = (record) => {
  if (!record?.lessonId || !record?.yearId) return "/yearsdashboard";

  const params = new URLSearchParams({
    lessonId: String(record.lessonId),
    yearId: String(record.yearId),
  });

  if (record.lessonDisplayName) {
    params.set("lessonDisplayName", String(record.lessonDisplayName));
  }

  return `/foundationLessonCom?${params.toString()}`;
};
